module.exports = __webpack_public_path__ + "img/IGNIS.c220bbd7.svg";